import { Link } from 'react-router-dom';

import PasswordResetRequestForm from './PasswordResetRequestForm';

function PasswordResetRequestPage() {
    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>Запрос сброса пароля</h1>
                    <PasswordResetRequestForm />
                    <Link className="button-link" to="/">
                        Вернуться на главную
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default PasswordResetRequestPage;
